const ALLOWED_PROTOCOLS = ['http:', 'https:'];

// Resolve a URL against the current page and only allow http(s), so a server- or
// config-supplied value such as `javascript:...` can never execute in our origin.
export const toSafeUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol) ? parsed.href : null;
  } catch {
    return null;
  }
};

// Open a URL in a new tab without giving the new page a handle on this window.
export const openSafeUrl = (url: string | null | undefined): boolean => {
  const safeUrl = toSafeUrl(url);
  if (!safeUrl) return false;
  window.open(safeUrl, '_blank', 'noopener,noreferrer');
  return true;
};
